import {
    TEST,
    GET_USER_DATA_STARTED,
    GET_USER_DATA_SUCCESS,
    GET_USER_DATA_FAILURE,
    GET_EVENTS_STARTED,
    GET_EVENTS_SUCCESS,
    GET_EVENTS_FAILURE,
    CHOICE_EVENT_STARTED,
    CHOICE_EVENT_SUCCESS,
    CHOICE_EVENT_FAILURE,
    GET_CABINET_MAIN_DATA_STARTED,
    GET_CABINET_MAIN_DATA_SUCCESS,
    GET_CABINET_MAIN_DATA_FAILURE,
    GET_CURRENT_EVENT_STARTED,
    GET_CURRENT_EVENT_SUCCESS,
    GET_CURRENT_EVENT_FAILURE,
    SET_MOBILE_NAV_STATUS,
    GET_ROADMAP_STARTED,
    GET_ROADMAP_SUCCESS,
    GET_ROADMAP_FAILURE,
    GET_LEADERBOARD_STARTED,
    GET_LEADERBOARD_SUCCESS,
    GET_LEADERBOARD_FAILURE,
    GET_MATRIX_STARTED,
    GET_MATRIX_SUCCESS,
    GET_MATRIX_FAILURE,
    GET_REFERRALS_STARTED,
    GET_REFERRALS_SUCCESS,
    GET_REFERRALS_FAILURE,
    GET_REFERRALS_MAIN_STARTED,
    GET_REFERRALS_MAIN_SUCCESS,
    GET_REFERRALS_MAIN_FAILURE,
    SET_MATRIX_SELL_WARNING_MODAL_STATUS,
    SET_MATRIX_SELL_SUCCESS_MODAL_STATUS,
    SET_MATRIX_SELL_MODAL_STATUS,
    SET_MATRIX_BUY_MODAL_STATUS,
    GET_CONTEST_WINNERS_STARTED,
    GET_CONTEST_WINNERS_SUCCESS,
    GET_CONTEST_WINNERS_FAILURE,
    GET_CONTEST_WINNERS_DATA_STARTED,
    GET_CONTEST_WINNERS_DATA_SUCCESS,
    GET_CONTEST_WINNERS_DATA_FAILURE,
    SET_REF_CODE_STARTED,
    SET_REF_CODE_SUCCESS,
    SET_REF_CODE_FAILURE,
    SEND_CONNECTED_WALLET_STARTED,
    SEND_CONNECTED_WALLET_SUCCESS,
    SEND_CONNECTED_WALLET_FAILURE,
    GET_TOKEN_COURSE_STARTED,
    GET_TOKEN_COURSE_SUCCESS,
    GET_TOKEN_COURSE_FAILURE,
    SEND_WALLET_AFTER_TRANSACTION_STARTED,
    SEND_WALLET_AFTER_TRANSACTION_SUCCESS,
    SEND_WALLET_AFTER_TRANSACTION_FAILURE,
    SET_MATRIX_BUY_QR_MODAL_STATUS,
    GET_RECEIVE_USDT_WALLET_STARTED,
    GET_RECEIVE_USDT_WALLET_SUCCESS,
    GET_RECEIVE_USDT_WALLET_FAILURE,
    GET_CONTEST_INFO_STARTED,
    GET_CONTEST_INFO_SUCCESS,
    GET_CONTEST_INFO_FAILURE,
    SET_SETTINGS_AVATAR_MODAL_STATUS,
    CHANGE_PASSWORD_STARTED,
    CHANGE_PASSWORD_SUCCESS,
    CHANGE_PASSWORD_FAILURE,
    CHANGE_AVATAR_STARTED,
    CHANGE_AVATAR_SUCCESS,
    CHANGE_AVATAR_FAILURE,
    GET_TRANSACTIONS_STARTED,
    GET_TRANSACTIONS_SUCCESS,
    GET_TRANSACTIONS_FAILURE,
    SET_BUY_REQUEST_STARTED,
    SET_BUY_REQUEST_SUCCESS,
    SET_BUY_REQUEST_FAILURE,
    SET_BUY_REQUEST_CONFIRM_STARTED,
    SET_BUY_REQUEST_CONFIRM_SUCCESS,
    SET_BUY_REQUEST_CONFIRM_FAILURE,
    SET_BUY_REQUEST_CANCEL_STARTED,
    SET_BUY_REQUEST_CANCEL_SUCCESS,
    SET_BUY_REQUEST_CANCEL_FAILURE
} from "./types";


const initialState = {
    test: false,
    mobileNavStatus: false,
    matrixSellWarningModalStatus: false,
    matrixSellSuccessModalStatus: false,
    matrixSellModalStatus: false,
    matrixBuyModalStatus: false,
    matrixBuyQrModalStatus: false,
    settingsAvatarModalStatus: false,
    userDataStarted: false,
    userData: false,
    userDataErr: false,
    eventsStarted: false,
    events: false,
    eventsErr: false,
    choiceEventStatusStarted: false,
    choiceEventStatus: false,
    choiceEventStatusErr: false,
    cabinetMainDataStarted: false,
    cabinetMainData: false,
    cabinetMainDataErr: false,
    currentEventStarted: false,
    currentEvent: false,
    currentEventErr: false,
    roadmapStarted: false,
    roadmap: false,
    roadmapErr: false,
    leaderboardStarted: false,
    leaderboard: false,
    leaderboardErr: false,
    matrixStarted: false,
    matrix: false,
    matrixErr: false,
    referralsStarted: false,
    referrals: false,
    referralsErr: false,
    referralsMainStarted: false,
    referralsMain: false,
    referralsMainErr: false,
    contestWinnersStarted: false,
    contestWinners: false,
    contestWinnersErr: false,
    contestWinnersDataStarted: false,
    contestWinnersData: false,
    contestWinnersDataErr: false,
    refCodeStatusStarted: false,
    refCodeStatus: false,
    refCodeStatusErr: false,
    sendConnectedWalletStatusStarted: false,
    sendConnectedWalletStatus: false,
    sendConnectedWalletStatusErr: false,
    tokenRateStarted: false,
    tokenRate: false,
    tokenRateErr: false,
    sendWalletAfterTransactionStatusStarted: false,
    sendWalletAfterTransactionStatus: false,
    sendWalletAfterTransactionStatusErr: false,
    receiveUsdtWalletStarted: false,
    receiveUsdtWallet: false,
    receiveUsdtWalletErr: false,
    contestInfoStarted: false,
    contestInfo: false,
    contestInfoErr: false,
    changePasswordStatusStarted: false,
    changePasswordStatus: false,
    changePasswordStatusErr: false,
    changeAvatarStatusStarted: false,
    changeAvatarStatus: false,
    changeAvatarStatusErr: false,
    transactionsStarted: false,
    transactions: false,
    transactionsErr: false,
    buyRequestStatusStarted: false,
    buyRequestStatus: false,
    buyRequestStatusErr: false,
    buyRequestConfirmStatusStarted: false,
    buyRequestConfirmStatus: false,
    buyRequestConfirmStatusErr: false,
    buyRequestCancelStatusStarted: false,
    buyRequestCancelStatus: false,
    buyRequestCancelStatusErr: false,
};

export function cabinetReducer(state = initialState, action) {
    switch (action.type) {
        case TEST:
            return {
                ...state,
                test: action.payload
            };
        case SET_MOBILE_NAV_STATUS:
            return {
                ...state,
                mobileNavStatus: action.payload
            };
        case SET_MATRIX_SELL_WARNING_MODAL_STATUS:
            return {
                ...state,
                matrixSellWarningModalStatus: action.payload
            };
        case SET_MATRIX_SELL_SUCCESS_MODAL_STATUS:
            return {
                ...state,
                matrixSellSuccessModalStatus: action.payload
            };
        case SET_MATRIX_SELL_MODAL_STATUS:
            return {
                ...state,
                matrixSellModalStatus: action.payload
            };
        case SET_MATRIX_BUY_MODAL_STATUS:
            return {
                ...state,
                matrixBuyModalStatus: action.payload
            };
        case SET_MATRIX_BUY_QR_MODAL_STATUS:
            return {
                ...state,
                matrixBuyQrModalStatus: action.payload
            };
        case SET_SETTINGS_AVATAR_MODAL_STATUS:
            return {
                ...state,
                settingsAvatarModalStatus: action.payload
            };
        case GET_USER_DATA_STARTED:
            return {
                ...state,
                userDataStarted: true
            };
        case GET_USER_DATA_SUCCESS:
            return {
                ...state,
                userData: action.payload,
                userDataStarted: false
            };
        case GET_USER_DATA_FAILURE:
            return {
                ...state,
                userDataErr: action.payload,
                userDataStarted: false
            };
        case GET_EVENTS_STARTED:
            return {
                ...state,
                eventsStarted: true
            };
        case GET_EVENTS_SUCCESS:
            return {
                ...state,
                events: action.payload,
                eventsStarted: false
            };
        case GET_EVENTS_FAILURE:
            return {
                ...state,
                eventsErr: action.payload,
                eventsStarted: false
            };
        case CHOICE_EVENT_STARTED:
            return {
                ...state,
                choiceEventStatusStarted: true
            };
        case CHOICE_EVENT_SUCCESS:
            return {
                ...state,
                choiceEventStatus: action.payload,
                choiceEventStatusStarted: false
            };
        case CHOICE_EVENT_FAILURE:
            return {
                ...state,
                choiceEventStatusErr: action.payload,
                choiceEventStatusStarted: false
            };
        case GET_CABINET_MAIN_DATA_STARTED:
            return {
                ...state,
                cabinetMainDataStarted: true
            };
        case GET_CABINET_MAIN_DATA_SUCCESS:
            return {
                ...state,
                cabinetMainData: action.payload,
                cabinetMainDataStarted: false
            };
        case GET_CABINET_MAIN_DATA_FAILURE:
            return {
                ...state,
                cabinetMainDataErr: action.payload,
                cabinetMainDataStarted: false
            };
        case GET_CURRENT_EVENT_STARTED:
            return {
                ...state,
                currentEventStarted: true
            };
        case GET_CURRENT_EVENT_SUCCESS:
            return {
                ...state,
                currentEvent: action.payload,
                currentEventStarted: false
            };
        case GET_CURRENT_EVENT_FAILURE:
            return {
                ...state,
                currentEventErr: action.payload,
                currentEventStarted: false
            };
        case GET_ROADMAP_STARTED:
            return {
                ...state,
                roadmapStarted: true
            };
        case GET_ROADMAP_SUCCESS:
            return {
                ...state,
                roadmap: action.payload,
                roadmapStarted: false
            };
        case GET_ROADMAP_FAILURE:
            return {
                ...state,
                roadmapErr: action.payload,
                roadmapStarted: false
            };
        case GET_LEADERBOARD_STARTED:
            return {
                ...state,
                leaderboardStarted: true
            };
        case GET_LEADERBOARD_SUCCESS:
            return {
                ...state,
                leaderboard: action.payload,
                leaderboardStarted: false
            };
        case GET_LEADERBOARD_FAILURE:
            return {
                ...state,
                leaderboardErr: action.payload,
                leaderboardStarted: false
            };
        case GET_MATRIX_STARTED:
            return {
                ...state,
                matrixStarted: true
            };
        case GET_MATRIX_SUCCESS:
            return {
                ...state,
                matrix: action.payload,
                matrixStarted: false
            };
        case GET_MATRIX_FAILURE:
            return {
                ...state,
                matrixErr: action.payload,
                matrixStarted: false
            };
        case GET_REFERRALS_STARTED:
            return {
                ...state,
                referralsStarted: true
            };
        case GET_REFERRALS_SUCCESS: {
            console.log(state.referrals?.referrals?.data, action.payload.referrals.data)
            const newData =
                action.payload.referrals.current_page > 1 && state.referrals?.data
                    ? [...state.referrals?.data, ...action.payload.referrals.data]
                    : action.payload.referrals.data;

            return {
                ...state,
                referrals: {
                    ...action.payload,
                    data: newData,
                },
                referralsStarted: false,
            };
        }
        case GET_REFERRALS_FAILURE:
            return {
                ...state,
                referralsErr: action.payload,
                referralsStarted: false
            };
        case GET_REFERRALS_MAIN_STARTED:
            return {
                ...state,
                referralsMainStarted: true
            };
        case GET_REFERRALS_MAIN_SUCCESS:
            return {
                ...state,
                referralsMain: action.payload,
                referralsMainStarted: false
            };
        case GET_REFERRALS_MAIN_FAILURE:
            return {
                ...state,
                referralsMainErr: action.payload,
                referralsMainStarted: false
            };
        case GET_CONTEST_WINNERS_STARTED:
            return {
                ...state,
                contestWinnersStarted: true
            };
        case GET_CONTEST_WINNERS_SUCCESS:
            return {
                ...state,
                contestWinners: action.payload,
                contestWinnersStarted: false
            };
        case GET_CONTEST_WINNERS_FAILURE:
            return {
                ...state,
                contestWinnersErr: action.payload,
                contestWinnersStarted: false
            };
        case GET_CONTEST_WINNERS_DATA_STARTED:
            return {
                ...state,
                contestWinnersDataStarted: true
            };
        case GET_CONTEST_WINNERS_DATA_SUCCESS:
            return {
                ...state,
                contestWinnersData: action.payload,
                contestWinnersDataStarted: false
            };
        case GET_CONTEST_WINNERS_DATA_FAILURE:
            return {
                ...state,
                contestWinnersDataErr: action.payload,
                contestWinnersDataStarted: false
            };
        case SET_REF_CODE_STARTED:
            return {
                ...state,
                refCodeStatusStarted: true
            };
        case SET_REF_CODE_SUCCESS:
            return {
                ...state,
                refCodeStatus: action.payload,
                refCodeStatusStarted: false
            };
        case SET_REF_CODE_FAILURE:
            return {
                ...state,
                refCodeStatusErr: action.payload,
                refCodeStatusStarted: false
            };
        case SEND_CONNECTED_WALLET_STARTED:
            return {
                ...state,
                sendConnectedWalletStatusStarted: true
            };
        case SEND_CONNECTED_WALLET_SUCCESS:
            return {
                ...state,
                sendConnectedWalletStatus: action.payload,
                sendConnectedWalletStatusStarted: false
            };
        case SEND_CONNECTED_WALLET_FAILURE:
            return {
                ...state,
                sendConnectedWalletStatusErr: action.payload,
                sendConnectedWalletStatusStarted: false
            };
        case GET_TOKEN_COURSE_STARTED:
            return {
                ...state,
                tokenRateStarted: true
            };
        case GET_TOKEN_COURSE_SUCCESS:
            return {
                ...state,
                tokenRate: action.payload,
                tokenRateStarted: false
            };
        case GET_TOKEN_COURSE_FAILURE:
            return {
                ...state,
                tokenRateErr: action.payload,
                tokenRateStarted: false
            };
        case SEND_WALLET_AFTER_TRANSACTION_STARTED:
            return {
                ...state,
                sendWalletAfterTransactionStatusStarted: true
            };
        case SEND_WALLET_AFTER_TRANSACTION_SUCCESS:
            return {
                ...state,
                sendWalletAfterTransactionStatus: action.payload,
                sendWalletAfterTransactionStatusStarted: false
            };
        case SEND_WALLET_AFTER_TRANSACTION_FAILURE:
            return {
                ...state,
                sendWalletAfterTransactionStatusErr: action.payload,
                sendWalletAfterTransactionStatusStarted: false
            };
        case GET_RECEIVE_USDT_WALLET_STARTED:
            return {
                ...state,
                receiveUsdtWalletStarted: true
            };
        case GET_RECEIVE_USDT_WALLET_SUCCESS:
            return {
                ...state,
                receiveUsdtWallet: action.payload,
                receiveUsdtWalletStarted: false
            };
        case GET_RECEIVE_USDT_WALLET_FAILURE:
            return {
                ...state,
                receiveUsdtWalletErr: action.payload,
                receiveUsdtWalletStarted: false
            };
        case GET_CONTEST_INFO_STARTED:
            return {
                ...state,
                contestInfoStarted: true
            };
        case GET_CONTEST_INFO_SUCCESS:
            return {
                ...state,
                contestInfo: action.payload,
                contestInfoStarted: false
            };
        case GET_CONTEST_INFO_FAILURE:
            return {
                ...state,
                contestInfoErr: action.payload,
                contestInfoStarted: false
            };
        case CHANGE_PASSWORD_STARTED:
            return {
                ...state,
                changePasswordStatusStarted: true
            };
        case CHANGE_PASSWORD_SUCCESS:
            return {
                ...state,
                changePasswordStatus: action.payload,
                changePasswordStatusStarted: false
            };
        case CHANGE_PASSWORD_FAILURE:
            return {
                ...state,
                changePasswordStatusErr: action.payload,
                changePasswordStatusStarted: false
            };
        case CHANGE_AVATAR_STARTED:
            return {
                ...state,
                changeAvatarStatusStarted: true
            };
        case CHANGE_AVATAR_SUCCESS:
            return {
                ...state,
                changeAvatarStatus: action.payload,
                changeAvatarStatusStarted: false
            };
        case CHANGE_AVATAR_FAILURE:
            return {
                ...state,
                changeAvatarStatusErr: action.payload,
                changeAvatarStatusStarted: false
            };
        case GET_TRANSACTIONS_STARTED:
            return {
                ...state,
                transactionsStarted: true
            };
        case GET_TRANSACTIONS_SUCCESS:
            return {
                ...state,
                transactions: action.payload,
                transactionsStarted: false
            };
        case GET_TRANSACTIONS_FAILURE:
            return {
                ...state,
                transactionsErr: action.payload,
                transactionsStarted: false
            };
        case SET_BUY_REQUEST_STARTED:
            return {
                ...state,
                buyRequestStatusStarted: true
            };
        case SET_BUY_REQUEST_SUCCESS:
            return {
                ...state,
                buyRequestStatus: action.payload,
                buyRequestStatusStarted: false
            };
        case SET_BUY_REQUEST_FAILURE:
            return {
                ...state,
                buyRequestStatusErr: action.payload,
                buyRequestStatusStarted: false
            };
        case SET_BUY_REQUEST_CONFIRM_STARTED:
            return {
                ...state,
                buyRequestConfirmStatusStarted: true
            };
        case SET_BUY_REQUEST_CONFIRM_SUCCESS:
            return {
                ...state,
                buyRequestConfirmStatus: action.payload,
                buyRequestConfirmStatusStarted: false
            };
        case SET_BUY_REQUEST_CONFIRM_FAILURE:
            return {
                ...state,
                buyRequestConfirmStatusErr: action.payload,
                buyRequestConfirmStatusStarted: false
            };
        case SET_BUY_REQUEST_CANCEL_STARTED:
            return {
                ...state,
                buyRequestCancelStatusStarted: true
            };
        case SET_BUY_REQUEST_CANCEL_SUCCESS:
            return {
                ...state,
                buyRequestCancelStatus: action.payload,
                buyRequestCancelStatusStarted: false
            };
        case SET_BUY_REQUEST_CANCEL_FAILURE:
            return {
                ...state,
                buyRequestCancelStatusErr: action.payload,
                buyRequestCancelStatusStarted: false
            };
        default:
            return state;
    }
}

